module.exports = __webpack_public_path__ + "img/LoginImg.21711aa7.png";